import { memo, forwardRef } from 'react';
import PropTypes from 'prop-types';
import { IFRAME_ID, PANEL_WIDTH, PickerTypes } from '../../constants';
import { jsx as _jsx } from "react/jsx-runtime";
const IFRAME_STYLE = {
  display: 'none',
  position: 'fixed',
  top: 0,
  right: 0,
  width: '100%',
  height: '100%',
  zIndex: 11111,
  border: '0 none'
};
const PanelIframe = /*#__PURE__*/forwardRef(({
  iframeUrl,
  pickerType
}, ref) => {
  const width = pickerType === PickerTypes.MEDIA_BRIDGE ? PANEL_WIDTH : '100%';
  return /*#__PURE__*/_jsx("iframe", {
    ref: ref,
    "data-picker-type": pickerType,
    id: pickerType === PickerTypes.DIGITAL_ASSET ? undefined : IFRAME_ID,
    src: iframeUrl,
    style: Object.assign({}, IFRAME_STYLE, {
      width
    }),
    scrolling: "no"
  });
});
PanelIframe.propTypes = {
  iframeUrl: PropTypes.string.isRequired,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
export default /*#__PURE__*/memo(PanelIframe);